const breadCrumb = "Lotação de Servidores - Cadastro de Servidores";

const routes = [
  {
    path: "/cadastro-de-gestores-administrativos",
    name: "cadastro-de-gestores-administrativos",
    meta: {
      allowedPermissions: ["gestor_administrativo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeGestoresAdministrativos/CadastroDeGestoresAdministrativosHome.vue"
      ),
  },
  {
    path: "/cadastro-de-gestores-administrativos/novo",
    name: "cadastro-de-gestores-administrativos-novo",
    meta: {
      allowedPermissions: ["gestor_administrativo_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeGestoresAdministrativos/CadastroDeGestoresAdministrativosCad.vue"
      ),
  },
  {
    path: "/cadastro-de-gestores-administrativos/editar/:id",
    name: "cadastro-de-gestores-administrativos-editar",
    meta: {
      allowedPermissions: ["gestor_administrativo_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeGestoresAdministrativos/CadastroDeGestoresAdministrativosEdit.vue"
      ),
  },
  {
    path: "/cadastro-de-gestores-administrativos/exonerar/:id",
    name: "cadastro-de-gestores-administrativos-exonerar",
    meta: {
      allowedPermissions: ["gestor_administrativo_exorneracao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeGestoresAdministrativos/CadastroDeGestoresAdministrativosExonerar.vue"
      ),
  },
];

export default routes;
